import { useMemo, type ReactNode } from 'react';
import { createApiClient, TokenManager, type ApiClient } from '@adiox/api';
import { SessionContext } from './session';

/** Provides the token manager and the typed API client. Tests pass their own instances. */
export function SessionProvider({
  tokens,
  api,
  children,
}: {
  tokens?: TokenManager;
  api?: ApiClient;
  children: ReactNode;
}) {
  const value = useMemo(() => {
    const t = tokens ?? new TokenManager();
    return { tokens: t, api: api ?? createApiClient(t) };
  }, [tokens, api]);
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}
